import React from "react";
import * as images from "../../resources/images";

const VerifyUser = () => {

  return (
    <div
      class="main_container"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // background: "linear-gradient(135deg, #e3f2fd, #f5f7fa)",
        background: "linear-gradient(135deg, #fde9d9, #fce3c1)",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div class="container_box "
      style={{
          backgroundColor: "white",
          padding: "0px 60px",
          borderRadius: "20px",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "500px",
          width: "90%",
        }}
        >
        <div class="reset_email  flex " style={{ flexDirection: "column", alignItems: "center" }}> 
         <div style={{marginTop: "30px", transform: "scale(0.8)", transformOrigin: "top left" }}>
          <img src={images.apuLogo1} />
        </div>
          <h4 className="w-100"
          style={{
              fontSize: "28px",
              color: "#1976d2",
              marginBottom: "20px",
              fontWeight: "700",
            }}
            >NOW, CHECK YOUR EMAIL</h4>

          <div class="input_box" style={{ marginTop: "10px" }}>
            <p style={{
                fontSize: "18px",
                lineHeight: "1.6",
                color: "#333",
              }}>
<span>
  A verification link has been sent to your registered email address.
  Please click the link to verify your email and continue with your application.
  Please check your <strong style={{ color: 'red', fontWeight: 'bold' }}>Spam/Junk</strong> folder if the email is not visible in your Inbox.
</span>

            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default VerifyUser;
